var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gridicons:location"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20 8.7C20 7.68882 19.7931 6.68754 19.391 5.75334C18.989 4.81913 18.3997 3.97029 17.6569 3.25528C16.914 2.54027 16.0321 1.97309 15.0615 1.58613C14.0909 1.19917 13.0506 1 12 1C10.9494 1 9.90914 1.19917 8.93853 1.58613C7.96793 1.97309 7.08601 2.54027 6.34315 3.25528C5.60028 3.97029 5.011 4.81913 4.60896 5.75334C4.20693 6.68754 4 7.68882 4 8.7C4 10.2257 4.46743 11.6447 5.26286 12.8415H5.25371L12 23L18.7463 12.8415H18.7383C19.5622 11.6058 20.0001 10.1683 20 8.7ZM12 12C11.0907 12 10.2186 11.6523 9.57563 11.0335C8.93265 10.4146 8.57143 9.57521 8.57143 8.7C8.57143 7.82479 8.93265 6.98542 9.57563 6.36655C10.2186 5.74768 11.0907 5.4 12 5.4C12.9093 5.4 13.7814 5.74768 14.4244 6.36655C15.0673 6.98542 15.4286 7.82479 15.4286 8.7C15.4286 9.57521 15.0673 10.4146 14.4244 11.0335C13.7814 11.6523 12.9093 12 12 12Z",
    fill: "#007D1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.d7e68c46ead2e1e62430b7577fc1d4d5.svg";
export { ForwardRef as ReactComponent };